import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { IdleService } from './core/services/idle.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
/**
 * App Component
 */
export class AppComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  idleWarningTime = 0;
  confirmationData = '';
  @ViewChild('sessionExpiryModal') sessionExpiryModal: { show: () => void; hide: () => void; };

  /**
   *
   * constructor
   */
  constructor(
    private router: Router,
    private idle: Idle,
    private idleService: IdleService,
  ) {
    this.idle.onIdleStart.pipe(takeUntilDestroyed()).subscribe(() => {
      this.sessionExpiryModal?.show();
    });
  }
  /**
 * loaded initially
 */
  ngOnInit() {
    this.idleService.reset();
    this.idle.onTimeoutWarning.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((countdown) => {
      this.idleWarningTime = countdown;
      this.confirmationData =
        `Your session is going to expire in ${this.idleWarningTime} ${this.idleWarningTime > 1 ? 'seconds' : 'second'}.`
    })
    this.idle.onIdleEnd.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.sessionExpiryModal.hide()
    });

    /** called after the inactive timeout */
    this.idle.onTimeout.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.sessionExpiryModal.hide()
      this.router.navigate(['/login']);

    });
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
